import { useCallback } from 'react';
import confetti from 'canvas-confetti';

interface ConfettiOptions {
  particleCount?: number;
  spread?: number;
  origin?: { x: number; y: number };
}

/**
 * ConfettiCelebration - Hook for triggering confetti animations
 *
 * Used by:
 * - ChoreCompletionModal.tsx (celebration on chore completion)
 *
 * Usage:
 * const { triggerConfetti } = useConfetti();
 * triggerConfetti(); // Call after successful chore completion
 */
export function useConfetti() {
  const triggerConfetti = useCallback((options: ConfettiOptions = {}) => {
    const defaults = {
      particleCount: 100,
      spread: 70,
      origin: { x: 0.5, y: 0.5 },
      colors: ['#15a2a2', '#1184a7', '#fea802', '#fe7434', '#0450b4'],
      ticks: 200,
      gravity: 1.2,
      scalar: 1.2,
    };

    confetti({
      ...defaults,
      ...options,
    });
  }, []);

  return { triggerConfetti };
}

/**
 * Burst confetti from a specific element (e.g., the complete button)
 */
export function burstFromElement(element: HTMLElement) {
  const rect = element.getBoundingClientRect();
  const x = (rect.left + rect.width / 2) / window.innerWidth;
  const y = (rect.top + rect.height / 2) / window.innerHeight;

  confetti({
    particleCount: 80,
    spread: 60,
    origin: { x, y },
    colors: ['#15a2a2', '#1184a7', '#fea802', '#fe7434', '#0450b4'],
  });
}
